<template>

    <div class="footer-wrapper">

        <div v-for=" ( route, routeKey ) in relevantRoutes "
            :class=" ( currentRoute.name == route.name ) ? 'icon-active' : '' "
            @click=" navTo( route.name ) "
            :key=" routeKey ">

            <font-awesome-icon class="footer-icon" :icon=" route.icon "/>
        </div>
        <div @click=" toggleOverflow() ">

            <font-awesome-icon class="footer-icon" icon="ellipsis-v" />
        </div>
    </div>
</template>

<script>

    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
    import { mapGetters, mapActions } from 'vuex';

    export default {

        name: 'footer-bar',
        computed: {

            ...mapGetters({

                currentRoute : 'currentRoute',
                routes       : 'nav/routes'
            }),
            relevantRoutes: function(){

                let routes = this.routes.filter( route => {

                    return route.onFooter;
                });
                return routes.sort( ( a, b ) => a.displaySequence - b.displaySequence );
            }
        },
        methods: {

            ...mapActions({

                toggleOverflow: 'nav/toggleOverflow'
            }),
            navTo( destination ){

                if( this.currentRoute.name != destination ){

                    this.$store.dispatch( 'orderMenu/clearState', true );
                    this.$router.push( { name: destination } );
                }
            }
        },
        components: {

            FontAwesomeIcon
        },
    }
</script>

<style scoped>

    .footer-wrapper {

        display: flex;
        align-items: center;
        justify-content: space-between;

        position: fixed;
        border-top: 1px solid rgba( 0, 0, 0, 0.2 );
        width: 100%;
        bottom: 0px;
        left: 0;
        right: 0;
        height: 65px;
        background-color: white;
        padding: 0px 25px;
        z-index: 450;
        box-shadow: 0px -6px 25px -7px rgba( 0, 0, 0, 0.5 );
    }

    .footer-wrapper > div {

        display: flex;
        align-items: center;
        justify-content: center;

        width: 35px;
        height: 35px;
    }

    .footer-icon {

        font-size: 22px;
    }

    .icon-active {

        color: #316bd8;
    }
</style>